import { action, computed, observable, runInAction, makeObservable} from 'mobx';
import authStore from './authStore';
import Storage from '../Storage';
import utils, { monthNoToName } from '../utils';

const CACHE_TIME = 1800000; // 1000 * 60 * 30

class HomeStore {
  @observable accounts = new Map();
  @observable loadingAccounts = new Map();
  @observable selectedMonth = null;

  @observable profits = new Map();

  @observable categoryLimits = new Map();

  @observable loadingCategories = new Map();
  @observable loadingProfits = new Map();
  @observable loadingProfitsBackground = new Map();

  @observable currentTilikausi = null;

  forceUpdatingAccounts = {};

  pageContentRef;

  persistCategoryLimits = false;
  scrollTop = 0;

  // last sync times
  profitsSynced = {};
  accountsSynced = {};

  constructor() {
    makeObservable(this);
    const profits = Storage.get('profits');

    if (profits) {
      this.profits.replace(profits);
    }

    const accounts = Storage.get('accounts');

    if (accounts) {
      this.accounts.replace(accounts);
    }
  }

  kirjauskausiToMonthName = (kirjauskausi) => {
    if (!this.profit) return;

    const total = kirjauskausi + this.profit.startmonth - 1;
    const month = total % 12;
    const year = this.profit.startyear + Math.floor((total - 1) / 12);

    return monthNoToName(month) + ' ' + year;
  }

  @computed
  get hasModule() {
    return authStore.hasModule(12);
  }

  @computed
  get timespan() {
    if (!this.profit || !this.profit.startdate) return '';
    return utils.ymd2dmy(this.profit.startdate) + ' - ' + utils.ymd2dmy(this.profit.enddate);
  }

  @computed
  get isLoadingAccounts() {
    return this.loadingAccounts.has(this.accountToken);
  }

  @computed
  get account() {
    return this.accounts.get(this.accountToken);
  }

  @computed
  get isLoadingProfits() {
    return this.loadingProfits.has(this.profitToken);
  }

  @computed
  get isLoadingProfitsBackground() {
    return this.loadingProfitsBackground.has(this.profitToken);
  }

  @computed
  get profitToken() {
    return authStore.companyToken + '.' + this.currentTilikausiId;
  }

  @computed
  get profit() {
    return this.profits.get(this.profitToken);
  }

  @computed
  get invalidHash() {
    if (this.computered === 0) {
      return true;
    }
    return false;
  }

  @action.bound
  clear() {
    this.selectedMonth = null;
    this.forceUpdatingAccounts = {};

    this.accounts.clear();
    this.profits.clear();

    this.categoryLimits.clear();

    this.profitsSynced = {};
    this.accountsSynced = {};

    this.reset();
  }

  @action.bound
  reset() {
    this.scrollTop = 0;
    this.persistCategoryLimits = false;
    this.currentTilikausi = null;
  }

  @action.bound
  async fetchReceipts(account, month) {
    const accountToken = this.accountToken;

    if (!this.accounts.has(accountToken)) {
      this.loadingAccounts.set(accountToken, true);
    } else {
      if (this.forceUpdatingAccounts[accountToken]) {
        this.loadingAccounts.set(accountToken, true);
        this.forceUpdatingAccounts[accountToken] = false;
      } else if (this.accountsSynced[accountToken] && this.accountsSynced[accountToken] > Date.now() - CACHE_TIME) {
        return;
      }
    }

    await this.updateAccounts(account, month, accountToken);

    runInAction(() => {
      this.loadingAccounts.delete(accountToken);
    });
  }

  persistCache() {
    Storage.set('accounts', this.accounts);
  }

  @action.bound
  async fetch() {
    if (!this.hasModule) {
      return;
    }

    const profitToken = this.profitToken;

    if (this.profits.has(profitToken)) {
      if (this.profitsSynced[profitToken] && this.profitsSynced[profitToken] > Date.now() - CACHE_TIME) {
        return;
      }
      this.loadingProfitsBackground.set(profitToken, true);
    } else {
      this.loadingProfits.set(profitToken, true);
    }
    //! are these needed, where is the function???
    // await this.update();

    runInAction(() => {
      this.loadingProfits.delete(profitToken);
      this.loadingProfitsBackground.delete(profitToken);
    });
  }


  @action.bound
  async refresh() {
    const profitToken = this.profitToken;

    if (this.loadingProfits.has(profitToken)) {
      return;
    }

    if (this.filteredBranch.TILINRO) {
      const accountToken = this.accountToken;

      this.forceUpdatingAccounts[accountToken] = true;
    }

    this.loadingProfits.set(profitToken, true);
    //! are these needed, where is the function???
    // await this.update();

    runInAction(() => {
      this.loadingProfits.delete(profitToken);
    });
  }


}

export default new HomeStore();
